import React from "react";
import GemapiHeroSection from "../components/PatrimoineSection/PatrinoimeHeroSection";
import GemapiNavigationMenu from "../components/PatrimoineSection/PatrimoineNavigationMenu";

const Gemapi = () => {
  return (
    <div>
      <GemapiHeroSection />
      <GemapiNavigationMenu />
    </div>
  );
};

export default Gemapi;
